import {castArray, flow, ifElse, isUndefined, map} from '@yandex-delivery/utils'

import type {Product, SddClaimProducts} from '../types'
import {toProduct} from './to-product'

/**
 * Преобразует элемент в начальный список продуктов.
 */
const toInitialProductList: () => Product[] = flow(toProduct, castArray)

/**
 * Преобразует каждый элемент списка грузовых товаров в продукт.
 */
const toFilledProductList = map(toProduct)

/**
 * Преобразует список грузовых товаров в список продуктов, или возвращает начальный список продуктов,
 * если список товаров не определен.
 */
export const toProducts: (items?: SddClaimProducts) => Product[] = ifElse(
  isUndefined,
  toInitialProductList,
  toFilledProductList,
)
